<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">Create Role</h4>
                <p class="text-subtitle-1">Role Creations</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <RoleForm
                    ref="form"
                    v-model="data"
                ></RoleForm>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn 
                    color="primary"
                    block 
                    @click="handleSave"
                    :loading="loading"      
                >
                Save</v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn 
                    block 
                    depressed
                    @click="handleCancel"
                >
                    cancel
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
    </div>
</template>

<script>
import PAlert from "./../../components/common/PAlert.vue"
import RoleForm from "./../../components/administration/RoleForm.vue"
import role from "./../../services/administration/role"
import { mapActions } from 'vuex'
export default {
    components: {
        RoleForm,
        PAlert
    },
    data() {
        return {
            data: {},
            alert:{
                title: "Alert",
                value: false,
                content: "",
                callback: null
            },
            loading: false
        }
    },
    methods: {
        ...mapActions({
           snackbar: "ui/snackbar/show"
        }),
        handleSave() {
            this.alert = { 
                ...this.alert , 
                value : true,
                content: "Are you sure you want to save?",
                callback: this.submit
            }
        },
        submit() {
            this.loading = true
            if(!this.$refs.form.validate()) return 
            role.create(this.data).then(response => {
                if(response.data?.record?.id){
                    this.snackbar({
                        text: response.data.message,
                        color: "success"
                        })     
                    this.$router.replace({ name: "RoleDisplay", params: {id : response.data.record.id}})
                }else{
                    console.log(Object.values(response.data))
                    let text = Object.values({...response.data, ...response.data.errors}).join()
                    this.snackbar({
                        text,
                        color: "error"
                    })
                }  
            }).finally(() => {
                this.loading = false
            }) 
        },
        handleCancel() {
            this.alert = { 
                ...this.alert , 
                value : true,
                content: "Are you sure you want to Cancel?",
                callback: this.cancel
            }            
        },
        cancel() {
            this.$router.back()
        }
    },  
    
}
</script>

<style>

</style>
  